import { sidebarUrlParamsSchema } from "@grafit/shared/utils/sidebar-url-params-schema";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const summarySearchSchema = sidebarUrlParamsSchema.extend({
  downloadOpeningSheet: z.boolean().optional(),
});

export const summarySearchSchemaValidator = zodValidator(summarySearchSchema);
